<!--
 * @Author: Merlin
 * @Date: 2024-01-12 18:53:09
 * @LastEditors: Gaho
 * @LastEditTime: 2025-01-09 11:08:27
 * @Description: 
-->
<template>
    <div class="jackpot-bar flex justify-center">
        <img
            class="w-[135px]"
            :src="JackPotImage"
        />
        <!-- 左右分界 -->
        <span class="mx-2 flex flex-col justify-between">
            <div class="">
                <slot></slot>
            </div>
            <span class="text-[#ffc51c] font-bold text-[15px] leading-none mt-1">
                <ClientOnly>
                    {{ handleExchangeRate(jackpotSize)?.toFixed(0) }}
                    {{ currentCurrency?.toLocaleUpperCase() }}
                </ClientOnly>
            </span>
        </span>

        <!-- ↓ 点击弹出窗口 -->
        <IconSvgUse
            class="cursor-pointer jackpot-icon"
            use="icon-question"
            size="18px"
            fill="#55657e"
            @click="handleOpenJacketPot"
        />
    </div>

    <!-- ↓弹出窗口 -->
    <ModalJackpot
        :game="gameName || 'Dice'"
        :visible="jackpotModal"
        :update="() => jackpotModal = false"
    />
</template>

<script setup lang="ts">
import JackPotImage from '@/assets/imgs/casino/dice/jackpot.png';
import { useGameHistoryStore } from '~/stores/cansino/gameHistory';
import useSettingsStore from '@/stores/settings';

const props = defineProps({
    gameName: String,
    jackpotSize: {
        type: Number,
        default: 0
    }
});

const userStore = useUserStore();
const gameHistoryStore = useGameHistoryStore();
const jackpotModal = ref(false);

const aHistoryToShow = computed(() => {
    if (!userStore.isLoggedIn) return [];
    let { response = [] } = gameHistoryStore.gameHistoryDelay || {};
    response = response.slice(0, 15).reverse(); 
    const aResult = response.map((cur) => {
        const gameValue = (cur.randomSeed || '').replace(/_.+/g, '');
        const oThisOne = {
            iVal: gameValue,
            sVal: gameValue,
            sType: (() => {
                if (cur.winAmount > 0) return 'bg-[#161f2c] text-[#2283f6]';
                else return 'bg-[#161f2c] text-[#fa305c]';
            })(),
        };
        return oThisOne;
    });
    return aResult;
});
const currentCurrency = computed(() => {
    return useSettingsStore().pickedCurrency || 'btc'; 
})
const handleOpenJacketPot = () => {
    jackpotModal.value = true;
}
</script>


<style lang="scss" scoped>
.jackpot-bar{
    opacity: 1; // 占位
}

.jackpot-icon {
    color: #55667f;
    margin: 2px 0 0; 
    &:hover {
        color: #fff;
    }
}
</style>
